import _ from 'lodash';

export const getResourcesSelector = state => _.get(state, 'resources.columns');
export const isFetchingSelector = state => _.get(state, 'resources.isFetching');
